var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-index',{ref:"projectTable",attrs:{"tableColCheck":_vm.tableColCheck,"plat-name":"bz"}}),_c('merge-project-dialog',{attrs:{"show-dialog":_vm.showMergeDialog},on:{"update:showDialog":function($event){_vm.showMergeDialog=$event},"update:show-dialog":function($event){_vm.showMergeDialog=$event},"updateData":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }